import { render, staticRenderFns } from "./BrandGroupModal.vue?vue&type=template&id=66cfa552"
import script from "./BrandGroupModal.vue?vue&type=script&lang=js"
export * from "./BrandGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports